import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, tap, filter, catchError, mergeMap} from 'rxjs/operators';
import {Observable, throwError} from 'rxjs';
import {BASE_URL} from '../../config/config';
import { NgxSpinnerService } from "ngx-spinner";
import {AuthService} from './../../login/auth.service';
import {Router} from '@angular/router';


@Injectable()

export class CabinetService {

  public DASBOARD_URL = BASE_URL.URL;
  private userId: any;
  private token: any;


  constructor(private http: HttpClient, private spinnerService: NgxSpinnerService, private authService: AuthService, private route: Router) {
  }

  getStoreNames(): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/names`, {
      headers: {
        'Authorization': 'Bearer ' + token 
      }
    }).pipe(
      map((res: any) => {        
        return res
      }), 
      tap(err => this.spinnerService.hide()),
      catchError(this.handleError.bind(this))
    );
  }

  getCabinetNames(storeId:string, fields :Array <string> = []): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    // @ts-ignore
    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/cabinets?fields=${fields}`,
      {
        headers: {
          'Authorization': 'Bearer ' + param.token 
        }
      }
    )
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getStoreCabinets(
    storeId :string, 
    deviceType = "", 
    page :string = "", 
    search :string = "",
    stockCountSort :string = "",
    missedCountSort :string = "",
    expiryCountSort :string = "",
    lastUpdatedAt :string = "",
  ): Observable<any> {
    this.spinnerService.show();
    let token = localStorage.getItem('token');

    return this.http.get(`${this.DASBOARD_URL}/stores/${storeId}/cabinets?page=${page}&search=${search}&device_type=${deviceType}&stock_count=${stockCountSort}&missed_stock_by_week=${missedCountSort}&expiry_products=${expiryCountSort}&last_updated_at=${lastUpdatedAt}`,
      {
        headers: {
          'Authorization': 'Bearer ' + token 
        }
      }
    )
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getCabinetDetails(cabinetId: string): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(this.DASBOARD_URL + '/cabinets/' + cabinetId, {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()), 
        catchError(this.handleError.bind(this))
      );
  }

  getCabinetProductCounts(cabinetId: string): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(this.DASBOARD_URL + '/cabinets/' + cabinetId + '/products/counts', {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe( 
        map((res: any) => {         
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getCabinetProductSummary(cabinetId: string, page: string = "", search: string = "", action: Array<string> = [], users: Array<string> = [], loggedAt: string = ""): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(`${this.DASBOARD_URL}/cabinets/${cabinetId}/products/summary?page=${page}&action=${action}&users=${users}&logged_at=${loggedAt}&search=${search}`, {
    // return this.http.get(this.DASBOARD_URL + '/cabinets/' + cabinetId + '/products/summary?page=' + page !== 0 ? page : '', {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getCabinetProducts(cabinetId: string, page: string = "", search: string = "", status: Array<string> = [], expiry: string = "", lastUpdatedAt: string = ""): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(`${this.DASBOARD_URL}/cabinets/${cabinetId}/products?page=${page}&search=${search}&status=${status}&expiry=${expiry}&last_updated_at=${lastUpdatedAt}`, {
    // return this.http.get(this.DASBOARD_URL + '/cabinets/' + cabinetId + '/products/summary?page=' + page !== 0 ? page : '', {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  showCabinetProducts(cabinetId: string, productId: string, status: Array<string> = [], expiry: string = "", lastUpdatedAt: string = ""): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(`${this.DASBOARD_URL}/cabinets/${cabinetId}/product/${productId}?status=${status}&expiry=${expiry}&last_updated_at=${lastUpdatedAt}`, {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getCabinetUsers(cabinetId: string, fields: string = ""): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(`${this.DASBOARD_URL}/cabinets/${cabinetId}/users?fields=${fields}`, {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  getCabinetLowStockAlert(cabinetId: string): Observable<any> {
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    return this.http.get(`${this.DASBOARD_URL}/alerts/cabinets/${cabinetId}`, {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }

  editCabinet(cabinetId, cabinetData): Observable<any> { 
    this.spinnerService.show();
    const param = {
      token: localStorage.getItem('token')
    };
    // @ts-ignore
    return this.http.post(`${this.DASBOARD_URL}/cabinets/${cabinetId}`, cabinetData, {
      headers: {
        'Authorization': 'Bearer ' + param.token 
      }
    })
      .pipe(
        map((res: any) => {        
          return res
        }), 
        tap(err => this.spinnerService.hide()),
        catchError(this.handleError.bind(this))
      );
  }
  
  private handleError(error: any){
    if (error.status === 401) {
      localStorage.clear();
      this.route.navigateByUrl(`/login?redirect_link=${this.route.url}`);
      this.spinnerService.hide();
      return
    }

    if (error.status === 422) {
      this.spinnerService.hide();
      return throwError(()=>error);
    }

    console.error('server error:', error);
    
    // if (error.error instanceof Error) {
    //   const errMessage = error.error.message;
    //   return Observable.throw(errMessage);
    //   // Use the following instead if using lite-server
    //   // return Observable.throw(err.text() || 'backend server error');
    // }
    // return Observable.throw(error || 'Node.js server error');
  }

}
